import Ticker from "@/components/Ticker";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import CollectionsGrid from "@/components/CollectionsGrid";
import FeaturedProducts from "@/components/FeaturedProducts";
import Testimonials from "@/components/Testimonials";
import SocialFeed from "@/components/SocialFeed";
import BlogStrip from "@/components/BlogStrip";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Index = () => (
  <div className="min-h-screen">
    <SEO
      url="/"
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "Store",
        name: "Plymhair & Extensions",
        description: "Premium hair extensions, wigs, braids and ponytails with fast UK delivery.",
        url: "https://www.plymhair.co.uk",
        telephone: "+44-1752-651631",
        email: "info@plymhair.co.uk",
        image: "https://www.plymhair.co.uk/plymhair-logo.svg",
        address: {
          "@type": "PostalAddress",
          streetAddress: "21 Market Avenue",
          addressLocality: "Plymouth",
          postalCode: "PL1 1PG",
          addressCountry: "GB",
        },
      }}
    />
    <Navbar transparent />
    <main>
      <HeroSection />
      <CollectionsGrid />
      <FeaturedProducts />
      <Testimonials />
      <BlogStrip />
      <SocialFeed />
    </main>
    <Footer />
  </div>
);

export default Index;
